import { Metadata } from './interface';

export const defaultMetadata: Metadata = {
    min: null,
    max: null,
    max_length: null,
    min_length: null,
    items: null,
    separator: '§'
};
